export const MANAGE_SEARCH = "manage_items_page:search_term_entered"
export const MANAGE_NEW_ITEM = "manage_items_page:new_item_pressed"
export const MANAGE_OVERFLOW_EDIT =
  "manage_items_page:row_overflow_edit_selected"
export const MANAGE_OVERFLOW_MAKE_INACTIVE_CONFIRMED =
  "manage_items_page:row_overflow_make_inactive_confirmed"
export const MANAGE_ADJUST_QTY = "manage_items_page:adjust_qty_pressed"
// Belongs to the item catalog, not to dry stack settings — it sits beside
// new_item_pressed and adjust_qty_pressed above, on the same screen they fire
// from. dry_stack_settings: covers the dry stack settings screen instead.
export const MANAGE_LAUNCH_ADDON_AVAILABILITY_TOGGLED =
  "manage_items_page:launch_addon_availability_toggled"
export const MANAGE_STATUS_FILTER = "manage_items_page:status_filter_changed"
export const MANAGE_BULK_MAKE_INACTIVE =
  "manage_items_page:bulk_make_inactive_confirmed"
export const MANAGE_BULK_REACTIVATE =
  "manage_items_page:bulk_reactivate_confirmed"
export const MANAGE_BULK_ADJUST_QTY =
  "manage_items_page:bulk_adjust_qty_pressed"
export const MANAGE_ADD_CATEGORY = "manage_category_modal:add_new_cat_confirmed"
export const MANAGE_DELETE_CATEGORY =
  "manage_category_modal:delete_cat_confirmed"
